// Registry of page layouts a theme can use. A theme's `layout` column picks
// one of these keys; the live routes render the matching components. Add a
// new layout by creating its components and adding one entry here.
export type ThemeLayoutKey = "classic" | "carmax";

export type ThemeLayout = {
  key: ThemeLayoutKey;
  label: string;
  description: string;
};

export const THEME_LAYOUTS: ThemeLayout[] = [
  {
    key: "classic",
    label: "Classic",
    description: "Your current homepage and unit page — the live look visitors see today.",
  },
  {
    key: "carmax",
    label: "CarMax-style",
    description: "New shopper-first homepage and unit page (search chips, payment estimate, sticky price panel).",
  },
];

export const DEFAULT_LAYOUT: ThemeLayoutKey = "classic";

export function isThemeLayoutKey(v: unknown): v is ThemeLayoutKey {
  return typeof v === "string" && THEME_LAYOUTS.some((l) => l.key === v);
}

export function themeLayoutLabel(key: string): string {
  return THEME_LAYOUTS.find((l) => l.key === key)?.label ?? key;
}
